import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { base_url_v2 } from 'src/environments/environment';


@Injectable()
export class EventService {

  constructor(public http: HttpClient) { }

  private httpOptions = {
    headers: new HttpHeaders({
      'Authorization': '',
    })
  };


  createSecurityHeaders() {
    const cookie = document.cookie.match(new RegExp('(^| )' + 'cuentame_token' + '=([^;]+)'));
    // const token = localStorage.getItem('id_token');
    // console.log(token)
    const token = cookie ? cookie[2] : null;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Authorization': token!,
      })
    };
    return this.httpOptions;
  }

  getWebinarData(evento) {
    return this.http.get<{ success: boolean, data: any }>(`${base_url_v2}/liveEvent/slug/${evento}/public?useCache=false`, this.createSecurityHeaders());
  }

  getWebinarAccess(id) {
    return this.http.get<{ success: boolean, data: any }>(`${base_url_v2}/liveEventAttendee/list/me?limit=20&offset=0&useCache=false&filters=[{"and": [{"field":"idLiveEventAttendee","operator":"=","value":"${id}"}]}]`, this.createSecurityHeaders());
  }

  getWebinarAccessV2(id) {
    return this.http.get<{ success: boolean, data: any }>(`${base_url_v2}/liveEvent/${id}/attendeeAccess/me`, this.createSecurityHeaders());
  }

}
